import { useEffect } from "react";
import URLService from "../service/urlService";

function RedirectToArrivalAnalyst() {
  useEffect(() => {
    window.location.href = URLService.generateRedirectUrl(
      window._env_.REACT_APP_ARRIVAL_ANALYST_URL
    );
  }, []);

  return null;
}

export default RedirectToArrivalAnalyst;
